import { appRoutePaths } from "../../app/router/utils";
import { NotificationItem } from "./types";

export const getNotificationViewPath = (
  notification: NotificationItem
): string | null => {
  const { apiType } = notification;

  if (apiType.startsWith("PAYMENT_LINK_")) {
    return appRoutePaths.paymentLinks;
  }

  if (apiType.startsWith("WITHDRAW_REQUEST_")) {
    return appRoutePaths.collections;
  }

  if (apiType.startsWith("VA_SETTLEMENT_")) {
    return appRoutePaths.virtualAccount;
  }

  if (apiType.startsWith("KLASHA_WIRE_")) {
    return appRoutePaths.klashaWire;
  }

  if (
    apiType.includes("PAYOUT") ||
    apiType.includes("BANK_TRANSFER") ||
    apiType.includes("FOREIGN_BANK")
  ) {
    return appRoutePaths.wallets;
  }

  return null;
};
